<div
  #chartContainer
  class="w-full h-full relative"
  (mousemove)="onPointerMove($event)"
  (mouseleave)="onPointerLeave()"
  (contextmenu)="onContainerContextMenu($event)"
>
  @if (hasScrollableViewport) {
    <div class="absolute left-3 top-0 z-[3] flex items-center gap-2 rounded-lg border border-line bg-card/95 px-2 py-1 shadow-sm backdrop-blur-sm">
      <button type="button" class="flex h-6 w-6 items-center justify-center rounded-md text-muted transition hover:bg-primary-bg hover:text-primary disabled:cursor-not-allowed disabled:opacity-35" [disabled]="!canMoveOlder" (click)="moveViewport('older')" aria-label="Show previous month" title="Previous month">
        <i class="pi pi-chevron-left text-[10px]" aria-hidden="true"></i>
      </button>
      <span class="min-w-[150px] text-center text-[10px] font-semibold text-dim">{{ viewportLabel }}</span>
      <button type="button" class="flex h-6 w-6 items-center justify-center rounded-md text-muted transition hover:bg-primary-bg hover:text-primary disabled:cursor-not-allowed disabled:opacity-35" [disabled]="!canMoveNewer" (click)="moveViewport('newer')" aria-label="Show next month" title="Next month">
        <i class="pi pi-chevron-right text-[10px]" aria-hidden="true"></i>
      </button>
    </div>
  }
  @if (options) {
    <div
      echarts
      [options]="options"
      class="w-full h-full"
      (chartInit)="onChartInit($event)"
      (chartClick)="onChartClick($event)"
      (chartContextMenu)="onChartContextMenu($event)"
    ></div>
  }

  @if (selectionOverlay) {
    <div
      class="selection-band"
      [style.left.px]="selectionOverlay.left"
      [style.width.px]="selectionOverlay.width"
      [style.--overview-selection-color]="selectedMetricColor"
    >
      <button
        type="button"
        class="selection-handle selection-handle--left"
        aria-label="Extend selection start"
        (pointerdown)="beginSelectionResize('start', $event)"
      ></button>
      <button
        type="button"
        class="selection-handle selection-handle--right"
        aria-label="Extend selection end"
        (pointerdown)="beginSelectionResize('end', $event)"
      ></button>
    </div>
  }
</div>
